import { GzAntimalwareOnDemandScanTaskOptionsFormWebComponent } from './component/GzAntimalwareOnDemandScanTaskOptionsFormWebComponent';

export { GzAntimalwareOnDemandScanTaskOptionsFormWebComponent };
